import { helper } from "./helper";

export const textImage = {
  init(destination) {
    textImage.setVideoBg(destination);
  },
  setVideoBg(destination) {

    if ($(destination.item).hasClass('js-text-image')) {

      if ($(destination.item).hasClass($(destination.item).data('id')) && $(destination.item).hasClass('js-has-video')) {
        helper.videoController('play', $(destination.item).find('video'));
      } else {
        setTimeout(() => {
          helper.videoController('stop', $(destination.item).find('video'));
        }, 1000);
      }

    }
  }
}



// WEBPACK FOOTER //
// ./scripts/components/featured/lib/textImage.js